<div aria-labelledby="character-traits-tab" class="tab-pane active container-fluid" role="tabpanel">
	<div class="row">
		<div class="col-12">
			<div class="d-flex justify-content-between align-items-start">
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.description"></span>
			</div>
		</div>
	</div>
	<div class="table-responsive">
		<table class="table table-striped table-bordered table-curved">
			<thead>
            <tr>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.table.header.trait"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.table.header.number.of.locations"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.table.header.number.of.lines"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.table.header.number.of.observations"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.table.header.distinct.observed.values"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.table.header.condition"></span>
			</th>
			<th>
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.table.header.limits"></span>
			</th>
			<th [ngStyle]="{ 'width': '120px' }">
				<span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.table.header.weight"></span>
			</th>
            </tr>
			<tbody *ngIf="traitFilterContext.hasCharacterTraits() else nodata">
			<tr *ngFor="let characterTrait of traitFilterContext.characterTraits">
				<td>
					<a (click)="$event.stopPropagation()" [queryParams]="{ name: characterTrait.name, type: 'character' }" [routerLink]="['/', { outlets: { popup: 'trait-observation-dialog/' + characterTrait.id } }]" queryParamsHandling="merge">
						<truncate-span [textInput]="characterTrait.name">
						</truncate-span>
					</a>
				</td>
				<td>{{ characterTrait.locationCount }}</td>
				<td>{{ characterTrait.germplasmCount }}</td>
				<td>{{ characterTrait.observationCount }}</td>
				<td>
					<truncate-span [maxLength]="MAX_NAME_DISPLAY_SIZE" [textInput]="characterTrait.values">
					</truncate-span>
				</td>
				<td [ngStyle]="{ width: '120px' }">
					<select (ngModelChange)="selectedCondition(characterTrait)" [(ngModel)]="characterTrait.condition" class="form-select">
						<ng-container>
							<option *ngFor="let opt of conditionOptions" [value]="opt.value">
								{{ opt.label | translate }}
							</option>
						</ng-container>
					</select>
				</td>
				<td>
					<input [(ngModel)]="characterTrait.limits" [disabled]="isLimitsDisabled(characterTrait)"
						   class="form-control" type="text"/>
				</td>
				<td [ngStyle]="{ 'min-width': '120px' }">
					<select [(ngModel)]="characterTrait.priority"
							[disabled]="characterTrait.condition === TraitCondition.DROP_TRAIT" class="form-select">
						<ng-container>
							<option *ngFor="let opt of traitWeightOptions" [value]="opt.value">
								{{ opt.label | translate}}
							</option>
						</ng-container>
					</select>
				</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<tbody>
			<tr>
				<td class="no-records" colspan="8" jhiTranslate="no.data"></td>
			</tr>
			</tbody>
		</ng-template>
	</div>
</div>
